import { createApi } from '@reduxjs/toolkit/query/react';
import { CreateSetBody, SetsData, UpdateSetBody } from 'store/sets/types';
import API_ROUTES from 'services/apiRoutes';
import { baseQueryWithAuth } from 'services/baseQueryWithAuth';

export const setsApi = createApi({
  reducerPath: 'setsApi',
  baseQuery: baseQueryWithAuth,
  tagTypes: ['Sets'],
  endpoints: builder => ({
    getSets: builder.query<SetsData[], { client_id: number }>({
      query: ({ client_id }) => API_ROUTES.GET_SETS(client_id),
      transformResponse: (response: { sets: SetsData[] } | SetsData[]) => {
        return Array.isArray(response) ? response : response.sets;
      },
      providesTags: ['Sets'],
    }),
    createSet: builder.mutation<SetsData, { body: CreateSetBody }>({
      query: ({ body }) => ({
        url: API_ROUTES.POST_SETS,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Sets'],
    }),
    updateSet: builder.mutation<SetsData, { set_id: string; body: UpdateSetBody }>({
      query: ({ set_id, body }) => ({
        url: API_ROUTES.PUT_SET(set_id),
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['Sets'],
    }),
    updateImageFilename: builder.mutation<
      void,
      { page_id_value: string; image_type: string; filename: string }
    >({
      query: ({ page_id_value, image_type, filename }) => ({
        url: '/admin/image_filenames',
        method: 'POST',
        body: { page_type: 'set', page_id_value, image_type, filename },
      }),
      invalidatesTags: ['Sets'],
    }),
  }),
});

export const {
  useGetSetsQuery,
  useLazyGetSetsQuery,
  useCreateSetMutation,
  useUpdateSetMutation,
  useUpdateImageFilenameMutation,
} = setsApi;
